<template>
  <el-dialog :visible.sync="visible" title="分类绑定" :close-on-click-modal="false" :close-on-press-escape="false" width="100%">
    <el-table
      v-loading="dataListLoading"
      :data="dataList"
      border
      @sort-change="dataListSortChangeHandle"
      height="400"
      style="width: 100%;">
      <el-table-column prop="id" label="ID" header-align="center" align="center" width="180"></el-table-column>
      <el-table-column prop="lname" label="系统分类" header-align="center" align="center"></el-table-column>
      <el-table-column prop="ccid" label="资源分类" header-align="center" align="center">
        <template slot-scope="scope">
          <el-select v-model="scope.row.ccid" filterable placeholder="请选择" @change="seleClass(scope.row)">
          <el-option
            v-for="item in cmsClass"
            :key="item.type_id"
            :label="item.type_name"
            :value="item.type_id"
            >
          </el-option>
        </el-select>

        </template>
        
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button  type="text" size="small" @click="caiji(scope.row.vod_id)">采集本部</el-button>
          </template>
        </el-table-column> -->
    </el-table>
    <el-pagination
      :current-page="page"
      :page-sizes="[20]"
      :page-size="limit"
      :total="total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="pageSizeChangeHandle"
      @current-change="pageCurrentChangeHandle">
    </el-pagination>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module-copy'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/cmsres/cmsresInfo/pageBinding',
        getDataListIsPage: false
      },
      cmsClass: [],
      dataForm: {
        id: ''
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      // this.getDataList()
      this.getClass()
      
      
      
    },
    // 失败信息
    caiji (id) {
      this.dataForm.vid = id
      this.$http.post(`/cmsres/cmsresInfo/caiji/`,this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.$alert(res.data.error)
      }).catch(() => {})
    },
    getClass(){
      this.$http.post(`/cmsres/cmsresInfo/getClass/`,this.dataForm).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.cmsClass = res.data
        this.getDataList()
        
      }).catch(() => {})
    },
    seleClass(value){
      
      this.$http.post(`/cmsres/cmsresInfo/bindingClass/`,value).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
       
        
      }).catch(() => {})
    }
  }
}
</script>
<style>
  .hidden-options {
    display: none;
  }
</style>